import { OrlikfyScreenshotDetect } from 'orlikfy-screenshot-detect';
import { PluginListenerHandle } from '@capacitor/core';

export class ScreenshotDetectService {
  isSupported(): Promise<boolean> {
    return OrlikfyScreenshotDetect.isSupported().then((result: { supported: boolean }) => result.supported);
  }

  startListening(): Promise<void> {
    return OrlikfyScreenshotDetect.startListening();
  }

  stopListening(): Promise<void> {
    return OrlikfyScreenshotDetect.stopListening();
  }

  addListener(callback: () => void): Promise<PluginListenerHandle> {
    return OrlikfyScreenshotDetect.addListener('screenshotTaken', callback);
  }
}
